import React, { FC, memo } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Chips } from '@ucheba/ui/components/Chips/desktop'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import styled from 'styled-components'
import { IBlockWithText } from '../types'
import ButtonRegEvent from '../../ButtonRegEvent/desktop'

const Image = styled.img`
  width: 100%;
`

const StyledChips = styled(Chips)`
  margin-right: ${sv.spacing.xxsmall};
  margin-bottom: ${sv.spacing.xsmall};
`

const GridColSC = styled(GridCol)`
  display: flex;
  align-items: end;
`

const BlockWithText: FC<IBlockWithText> = (props) => {
  const { title, description, chips, button, image } = props

  if (image) {
    return (
      <>
        <Spacing spacing='uxlarge' />

        {title && (
          <>
            <Heading h2={title} />

            <Spacing spacing='small' />
          </>
        )}

        {chips && chips.length > 0 && (
          <>
            {chips.map((chip, key) => (
              <StyledChips key={key} color={chip.color}>
                {chip.text}
              </StyledChips>
            ))}

            <Spacing spacing='small' />
          </>
        )}

        <Grid>
          <GridCol uxs={12}>{description && <Text>{description}</Text>}</GridCol>

          <GridColSC uxs={12}>
            <Image src={image} />
          </GridColSC>
        </Grid>

        {button && (
          <>
            <Spacing spacing='xlarge' />

            <ButtonRegEvent color={button.color} />
          </>
        )}
      </>
    )
  }

  return (
    <>
      <Spacing spacing='uxlarge' />

      {title && (
        <>
          <Heading h2={title} />

          <Spacing spacing='small' />
        </>
      )}

      {chips && chips.length > 0 && (
        <>
          {chips.map((chip, key) => (
            <StyledChips key={key} color={chip.color}>
              {chip.text}
            </StyledChips>
          ))}

          <Spacing spacing='small' />
        </>
      )}

      {description && <Text>{description}</Text>}

      {button && (
        <>
          <Spacing spacing='xlarge' />

          <ButtonRegEvent color={button.color} />
        </>
      )}
    </>
  )
}

export default memo(BlockWithText)
